const initialState = {
    isOpen: false,
    data: {},
    rate: 0,
};
const modalRating = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_RATING':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalRating;
